import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import {
  Box,
  Divider,
  IconButton,
  List,
  Stack,
  Toolbar,
  Typography,
} from '@mui/material';
import MuiDrawer from '@mui/material/Drawer';
import { grey } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import * as React from 'react';
import * as Redux from 'react-redux';
import { BLUE_COLOR } from '../../../constants/ColorsConst';
import { APP_NAME, APP_VERSIOM } from '../../../constants/ConfigConst';
import { generateRandomNumber } from '../../../helpers';
import {
  ADMIN_CONST,
  ENTITY_CONST,
  ROOT_CONST,
} from '../../../modules/auth/login/LoginReducer';
import * as ROUTES from '../../../router/Routes';
import InfoEntidadComponent from './InfoEntidad';
import ItemDrawer from './ItemDrawer';

export const drawerWidth = 300;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

const SidebarTemplate = ({ openSidebar, toggleDrawer }) => {
  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);

  // React.useEffect(() => {
  //   entVistasStore.all.forEach((el) => {
  //     const vista = ROUTES.modulosSistema.find((mod) => mod.id === el.vista.id);
  //     if (vista) setModulosSistema((old) => [...old, vista]);
  //   });
  // }, [entVistasStore.all]);

  function checkModulo(value) {
    if (loginStore.isRoot) return value;

    const { vistas } = loginStore;

    if (Array.isArray(value)) {
      return value.filter((el) => vistas.some((row) => row.id === el.id));
    }

    if (typeof value === 'object') {
      return vistas.find((row) => row.id === value.id) ? value : null;
    }

    return null;
  }

  const ROOT_ARRAY = [ROOT_CONST];
  const ADMIN_ARRAY = [...ROOT_ARRAY, ADMIN_CONST];
  const ENTITY_ARRAY = [...ADMIN_ARRAY, ENTITY_CONST];

  const controlEstudios = [
    ROUTES.asistenciasDiarias,
    ROUTES.aulario,
    ROUTES.boletines,
    ROUTES.bloquesPedagogicos,
    ROUTES.entCarreras,
    ROUTES.docentes,
    ROUTES.estudiantes,
    ROUTES.familiares,
    ROUTES.horarios,
    ROUTES.materias,
    ROUTES.matriculas,
    ROUTES.entNivelesAcademicos,
    ROUTES.periodosAcademicos,
    ROUTES.planEvaluacion,
    ROUTES.secciones,
  ];

  const lista = (
    <List component="nav" sx={{ width: '100%', mx: 0.5 }}>
      <ItemDrawer
        key={generateRandomNumber()}
        item={ROUTES.dashboard}
        openDrawer={openSidebar}
      />
      {loginStore.isRoot && (
        <ItemDrawer
          key={generateRandomNumber()}
          item={{
            ...ROUTES.root,
            vistas: [
              ROUTES.carnetOnEdu,
              ROUTES.carreras,
              ROUTES.deportes,
              ROUTES.entidades,
              ROUTES.modulos,
              ROUTES.monedas,
              ROUTES.operadoras,
              ROUTES.perfiles,
              ROUTES.profesiones,
              ROUTES.nivelesAcademicos,
              ROUTES.tiposActividadesExtraCur,
              ROUTES.suscripciones,
              ROUTES.usuarios,
              ROUTES.system,
              ROUTES.vistas,
            ],
          }}
          openDrawer={openSidebar}
        />
      )}
      <ItemDrawer
        key={generateRandomNumber()}
        item={ROUTES.herramientas}
        openDrawer={openSidebar}
      />
      <ItemDrawer
        key={generateRandomNumber()}
        item={ROUTES.eventos}
        openDrawer={openSidebar}
      />

      {/* <ItemDrawer
        key={generateRandomNumber()}
        item={ROUTES.tablero}
        openDrawer={openSidebar}
      /> */}

      {entidadesStore.activo && (
        <>
          {/* Academicos */}
          {loginStore.isTeacher &&
            checkModulo([
              ROUTES.temasAcademicos,
              ROUTES.evaluaciones,
              ROUTES.actividadesAcademicas,
            ]).length > 0 && (
              <ItemDrawer
                key={generateRandomNumber()}
                item={{
                  ...ROUTES.academico,
                  vistas: checkModulo([
                    ROUTES.temasAcademicos,
                    ROUTES.evaluaciones,
                    ROUTES.actividadesAcademicas,
                  ]),
                }}
                openDrawer={openSidebar}
              />
            )}
          {/* -------------------------------- */}

          {/* Accesos del personal */}
          {ENTITY_ARRAY.includes(loginStore.rol) &&
            checkModulo(ROUTES.accesos) && (
              <ItemDrawer
                key={generateRandomNumber()}
                item={ROUTES.accesos}
                openDrawer={openSidebar}
              />
            )}
          {/* -------------------------------- */}

          {/* Administracion */}
          {ENTITY_ARRAY.includes(loginStore.rol) &&
            checkModulo(ROUTES.recibos) && (
              <ItemDrawer
                key={generateRandomNumber()}
                item={{
                  ...ROUTES.administracion,
                  vistas: [
                    ROUTES.panelAdministracion,
                    ROUTES.conceptos,
                    ROUTES.recibos,
                  ],
                }}
                openDrawer={openSidebar}
              />
            )}
          {/* -------------------------------- */}

          {/* Ajustes */}
          {(ENTITY_ARRAY.includes(loginStore.rol) ||
            loginStore.isAdminTeacher) &&
            checkModulo(ROUTES.ajustes) && (
              <ItemDrawer
                key={generateRandomNumber()}
                item={ROUTES.ajustes}
                openDrawer={openSidebar}
              />
            )}
          {/* -------------------------------- */}

          {/* Control de estudios */}
          {ENTITY_ARRAY.includes(loginStore.rol) &&
            checkModulo(controlEstudios).length > 0 && (
              <ItemDrawer
                key={generateRandomNumber()}
                item={{
                  ...ROUTES.controlEstudios,
                  vistas: checkModulo(controlEstudios),
                }}
                openDrawer={openSidebar}
              />
            )}
          {/* -------------------------------- */}

          {/* Deportes */}
          {ENTITY_ARRAY.includes(loginStore.rol) &&
            checkModulo(ROUTES.juegosDeportivos) && (
              <ItemDrawer
                key={generateRandomNumber()}
                item={{
                  ...ROUTES.juegosDeportivos,
                  vistas: [
                    ROUTES.panelDeportivo,
                    ROUTES.equipos,
                    ROUTES.juegos,
                    ROUTES.jugadores,
                    ROUTES.resultados,
                    ROUTES.torneos,
                  ],
                }}
                openDrawer={openSidebar}
              />
            )}
          {/* -------------------------------- */}

          {/* Control de estudios */}
          {loginStore.isAdminTeacher && (
            <ItemDrawer
              key={generateRandomNumber()}
              item={{
                ...ROUTES.controlEstudios,
                vistas: checkModulo([
                  ROUTES.asistenciasDiarias,
                  ROUTES.bloquesPedagogicos,
                  ROUTES.entCarreras,
                  ROUTES.estudiantes,
                  ROUTES.horarios,
                  ROUTES.materias,
                  ROUTES.entNivelesAcademicos,
                  ROUTES.periodosAcademicos,
                  ROUTES.planEvaluacion,
                  ROUTES.secciones,
                ]),
              }}
              openDrawer={openSidebar}
            />
          )}
          {/* -------------------------------- */}

          {loginStore.isTeacher &&
            !loginStore.isAdminTeacher &&
            checkModulo(ROUTES.estudiantes) && (
              <ItemDrawer
                key={generateRandomNumber()}
                item={ROUTES.estudiantes}
                openDrawer={openSidebar}
              />
            )}

          {/* {loginStore.isFamily && checkModulo(ROUTES.estudiantes) && (
            <ItemDrawer
              key={generateRandomNumber()}
              item={ROUTES.estudiantes}
              openDrawer={openSidebar}
            />
          )} */}

          {checkModulo(ROUTES.notas) && (
            <ItemDrawer
              key={generateRandomNumber()}
              item={{
                ...ROUTES.notas,
                vistas: [ROUTES.panelNotas, ROUTES.notasEvaluativas],
              }}
              openDrawer={openSidebar}
            />
          )}

          {loginStore.isTeacher &&
            !loginStore.isAdminTeacher &&
            checkModulo(ROUTES.planEvaluacion) && (
              <ItemDrawer
                key={generateRandomNumber()}
                item={ROUTES.planEvaluacion}
                openDrawer={openSidebar}
              />
            )}

          {/* {loginStore.isFamily && checkModulo(ROUTES.planEvaluacion) && (
            <ItemDrawer
              key={generateRandomNumber()}
              item={ROUTES.planEvaluacion}
              openDrawer={openSidebar}
            />
          )} */}

          {(loginStore.isRoot || checkModulo(ROUTES.reportes)) && (
            <ItemDrawer
              key={generateRandomNumber()}
              item={ROUTES.reportes}
              openDrawer={openSidebar}
            />
          )}
          {(loginStore.isRoot || checkModulo(ROUTES.resumenes)) && (
            <ItemDrawer
              key={generateRandomNumber()}
              item={ROUTES.resumenes}
              openDrawer={openSidebar}
            />
          )}

          {/* {loginStore.isRoot && (
            <ItemDrawer
              key={generateRandomNumber()}
              item={ROUTES.verificador}
              openDrawer={openSidebar}
            />
          )} */}

          {ENTITY_ARRAY.includes(loginStore.rol) &&
            checkModulo(ROUTES.usuarios) && (
              <ItemDrawer
                key={generateRandomNumber()}
                item={ROUTES.usuEntidades}
                openDrawer={openSidebar}
              />
            )}
        </>
      )}
    </List>
  );

  return (
    <Drawer variant="permanent" open={openSidebar}>
      <Box>
        <Toolbar
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: [1],
          }}
        >
          <InfoEntidadComponent />
          <IconButton onClick={toggleDrawer}>
            <ChevronLeftIcon />
          </IconButton>
        </Toolbar>
        <Divider />
      </Box>
      <Box
        sx={{
          display: 'flex',
          overflowX: 'hidden',
          overflowY: 'auto',
          position: 'relative',
          minHeight: '80%',
          mb: '2em',
          '::-webkit-scrollbar': {
            width: '7px',
          },
          '::-webkit-scrollbar-track': {
            background: grey[300] /* color of the tracking area */,
          },
          '::-webkit-scrollbar-thumb': {
            backgroundColor: BLUE_COLOR /* color of the scroll thumb */,
            borderRadius: '4px' /* roundness of the scroll thumb */,
          },
        }}
      >
        {lista}
      </Box>
      <Stack
        direction="column"
        alignContent="center"
        justifyContent="center"
        sx={{
          mb: '1em',
        }}
      >
        <Typography
          variant="body1"
          color="initial"
          textAlign="center"
          fontWeight="bold"
        >
          {APP_VERSIOM}
        </Typography>
        <Typography
          variant="body1"
          color="initial"
          textAlign="center"
          fontWeight="bold"
        >
          {APP_NAME}
        </Typography>
        {/* <Typography variant="caption" fontWeight="bold" textAlign="center">
          OnEDU
        </Typography> */}
      </Stack>
    </Drawer>
  );
};

export default SidebarTemplate;
